<template>
  <div class="">Config</div>
</template>

<script>
export default {
  components: {},
};
</script>
